import React from 'react'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { withData } from '../withData'
import { DoseCard } from '../Card/DoseCard'
import { Card, Modal, Icon } from 'antd'
import qs from 'query-string'
import { graphql } from '../graphql'
import { compose } from 'recompose'
import './DoseList.scss'

const confirm = Modal.confirm

const query = `
  query {
    doseList() {
      id,
      name,
      timeReminders {
        method,
        quantity,
        time
      },
      dateReminders,
      dateRemindersType,
      startDate,
      endDate,
      remaining
    }
  }
`

const removePrompt = (e, doseInfo, data, setData) => {
  e.stopPropagation()
  e.preventDefault()
  console.log('removing', doseInfo)
  confirm({
    title: `จะลบโดสยา ${doseInfo.name} หรือไม่?`,
    content: 'หากลบแล้วจะไม่มีการแจ้งเตือนโดสยานี้อีก',
    okText: 'ลบโดสยา',
    cancelText: 'ยกเลิก',
    onOk: () => {
      const deleteMutation = `
        mutation {
          removeDose(
            doseId: "${doseInfo.id}"
          ) {
            success
          }
        }
      `
      graphql(deleteMutation).then((response) => {
        if (_.get(response, 'data.removeDose.success')) {
          setData({
            data: {
              doseList: _.reject(data.data.doseList, ({ id }) => id === doseInfo.id)
            }
          })
          console.log('success!')
        }
      })
    },
    onCancel: () => {
      console.log('Cancelled')
    }
  })
}

const enhance = compose(
  withData(query)
)

const DoseList = ({ match, data, setData }) => {
  const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
  const patientId = _.get(match, 'params.patientId')
  const displayName = _.get(data, 'data.medications.displayName')
  const displayImage = _.get(data, 'data.medications.displayImage')
  const patient = _.get(data, 'data.medications.patient')
  return (
    <div className="doses">
      <Helmet>
        <title>รายชื่อโดสยา</title>
      </Helmet>
      <h2>
        <center>รายชื่อโดสยา</center>
      </h2>
      <h4 className="subtitle">
        <center>(กดเพื่อแก้ไข)</center>
      </h4>
      <br />
      {_.map(_.compact(_.get(data, 'data.doseList') || []), (doseInfo) => {
        if (doseInfo) {
          return (
            <div className="dose" key={doseInfo.id}>
              <Link to={`/doses/${doseInfo.id}?token=${token}`}>
                <DoseCard doseInfo={doseInfo} />
              </Link>
              <Icon className="delete-button-icon" type="close-circle-o" onClick={(e) => removePrompt(e, doseInfo, data, setData)} />
            </div>
          )
        }
        return ''
      })}
      <Link to={`/doses/add?token=${token}`}>
        <Card className="dose">
          <div className="add-dose">
            <Icon type="plus" /> เพิ่มโดส
          </div>
        </Card>
      </Link>
    </div>
  )
}

export default enhance(DoseList)



// WEBPACK FOOTER //
// ./src/DoseList/DoseList.js